var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordpress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wordpress_svgrepo.com",
    clipPath: "url(#clip0_739_16641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99662 -0.00195312C3.58399 -0.00170312 -0.00272827 3.58558 -0.00350952 7.99792C-0.00272827 12.41 3.58399 15.9973 7.99662 15.998C12.4087 15.9973 15.996 12.41 15.9965 7.99792C15.996 3.58558 12.4087 -0.00170312 7.99662 -0.00195312ZM13.1445 13.1455C11.824 14.4656 10.0052 15.2816 7.99662 15.2819C5.98774 15.2816 4.16877 14.4656 2.84874 13.1455C1.52874 11.8255 0.712959 10.0063 0.712678 7.99792C0.712928 5.9893 1.52874 4.17058 2.84874 2.85008C4.16877 1.53055 5.98774 0.714516 7.99662 0.714234C10.0052 0.714484 11.824 1.53055 13.1445 2.85005C14.464 4.17055 15.28 5.98902 15.2803 7.99789C15.28 10.0063 14.464 11.8255 13.1445 13.1455Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.24722 5.43066H2.20206C1.85391 6.2156 1.65925 7.08332 1.65925 7.99744C1.65925 10.4917 3.10016 12.6481 5.19482 13.6824L2.2475 5.43066H2.24722Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5966 5.69722C11.0503 4.93309 11.1313 3.37103 12.136 3.19991C11.0254 2.24141 9.57976 1.66016 7.99785 1.66016C5.75116 1.66016 3.77891 2.82991 2.65357 4.59319H4.97326V5.43053H4.03829L6.20294 11.4895L7.72138 7.43062L7.00644 5.4305H5.92498V4.59316H9.80701V5.4305H8.79582L10.9788 11.5422L12.0851 8.58678C12.2812 7.79015 12.1666 6.49644 11.5966 5.69722Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.8872 5.66309C13.8847 5.68715 13.8822 5.71149 13.8787 5.73509C13.7254 6.76384 12.7726 9.02031 12.7726 9.02031L11.3932 12.7077L11.0854 13.531C13.023 12.4471 14.3335 10.3764 14.3335 7.99806C14.3335 7.17299 14.1742 6.3858 13.8872 5.66309Z",
    fill: "#135FC2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.61753 12.6546L6.09675 14.0464C6.69681 14.235 7.33475 14.3366 7.997 14.3366C8.72075 14.3366 9.41538 14.2139 10.0633 13.9902L8.13597 8.59473L6.61753 12.6546Z",
    fill: "#135FC2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_739_16641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/Wordpress.0387e47d1f879eda4d247dcc8ee46eab.svg";
export { ForwardRef as ReactComponent };